import moment from 'moment';

export const defaultDateFrom = moment().subtract(6, 'day').format('YYYY-MM-DD');
export const defaultDateTo = moment().format('YYYY-MM-DD');

export const DEFAULT_PAGE_SIZE = 10;
